import styled from 'styled-components';
import { Text } from '@rsos/components/capstone/base';

export const BasePrimaryText = styled(Text).attrs({
  color: 'primaryText',
  size: 'normal',
})``;
export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  display: flex;
  width: 13px;
  height: 13px;
  margin: 0 10px 0 0;
  flex: 0 0 auto;
`;
